import { render, staticRenderFns } from "./IbProcessSuccessful.vue?vue&type=template&id=62fa3a3e&scoped=true"
import script from "./IbProcessSuccessful.vue?vue&type=script&lang=js"
export * from "./IbProcessSuccessful.vue?vue&type=script&lang=js"
import style0 from "./IbProcessSuccessful.vue?vue&type=style&index=0&id=62fa3a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa3a3e",
  null
  
)

export default component.exports